import { StepCard, StepInput, ChipStack, FileInput } from 'components';
import { IStepCardData, InputType, AnalysisInput } from 'types';

interface IProps extends IStepCardData {
  activeStep: number;
}

export const FormStepCard = ({ activeStep, title, description, input }: IProps) => (
  <StepCard activeStep={activeStep} title={title} description={description}>
    {input.type === InputType.FILE ? (
      <FileInput name={input.name} />
    ) : (
      <>
        <StepInput
          inputName={AnalysisInput.INPUT}
          fieldArrayName={input.name}
          placeholder={input.placeholder}
        />
        <ChipStack name={input.name} />
      </>
    )}
  </StepCard>
);
